<template>
  <div class="summary-container">
    <progress-nav :blocks="blockAmount"></progress-nav>
    <div class="summary-content">
      <div class="chart-container" v-if="total">
        <pie-nav
          v-if="currentTotalStakes"
          :totalstake="currentTotalStakes"
          :totalnostake="total - currentTotalStakes"
        ></pie-nav>
        <amount-nav
          v-if="currentTotalStakes"
          :amountstake="currentTotalStakes"
          :amountnostake="total - currentTotalStakes"
          :text1="$t('summary.totalstake')"
          :text2="$t('summary.oftotal')"
        ></amount-nav>
      </div>
      <div class="flex-start-column">
        <div class="flex-start-column total-nodes">
          <p class="node-num ft64">{{ nodeAmount.total_node_count }}</p>
          <p class="node-text">{{ $t('summary.totaltext') }}</p>
        </div>
        <div class="detail-nodes">
          <div class="flex-start-column">
            <p class="node-num">{{ nodeAmount.consensus_node_count }}</p>
            <p class="node-text">{{ $t('summary.consensustext') }}</p>
          </div>
          <div class="flex-start-column">
            <p class="node-num">{{ nodeAmount.candidate_node_count }}</p>
            <p class="node-text">{{ $t('summary.candidatetext') }}</p>
          </div>
          <div class="flex-start-column">
            <p class="node-num">{{ nodeAmount.sync_node_count }}</p>
            <p class="node-text">{{ $t('summary.synchronoustext') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressNav from "./Progress.vue";
import PieNav from "./Piechart.vue";
import AmountNav from "./Stakeamount";
export default {
  name: "nodesSummary",
  components: {
    ProgressNav,
    PieNav,
    AmountNav
  },
  computed: {
    blockAmount() {
      return this.$store.getters.blockstonext.count_to_next_round || 0;
    },
    nodeAmount() {
      return this.$store.getters.nodeSummary || {};
    },
    totalstake() {
      return this.$store.getters.totalstakeamount || {};
    },
    total() {
      const totalsupply = this.$store.getters.totalsupply || {};
      return totalsupply.ont
    },
    currentTotalStakes() {
      return this.totalstake.current_total_stakes
    }
  },
  watch: {
    totalstake: function() {
      this.getTotalSupply();
    },
  },
  data() {
    return {
      totalont: 1000000000,
    };
  },
  mounted() {
    this.getBlocksAmount();
    this.intervalBlock1 = setInterval(() => {
      this.getBlocksAmount();
    }, 6000);
    this.getNodeAmount();
    this.getTotalStake();
  },
  methods: {
    getBlocksAmount() {
      this.$store.dispatch("getBlocksToNextRound").then();
    },
    getNodeAmount() {
      this.$store.dispatch("getNodeSummary").then();
    },
    getTotalStake() {
      this.$store.dispatch("getTotalStake").then();
    },
    getTotalSupply() {
      this.$store.dispatch("getTotalSupply").then();
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalBlock1);
  },
};
</script>
<style lang="scss" scoped>
.summary-container {
  padding-left: 30px;
  padding-right: 30px;
  max-width: 1200px;
  margin: auto;
  padding-top: 100px;
  color: #181717;

  @include mobile {
    padding: 28px 20px 0 20px;
  }
}
.summary-content {
  margin-top: 120px;
  padding-bottom: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include mobile {
    margin-top: 28px;
    display: block;
    padding-bottom: 52px;
  }
}
.chart-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  @include mobile {
    gap: 8px;
    margin-bottom: 40px;
  }
}
.flex-start-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.total-nodes {
  padding: 8px 0 24px;
  border-bottom: 1px solid rgba(24, 23, 23, 0.2);
  width: 100%;
}
.detail-nodes {
  display: flex;
  align-items: flex-start;
  gap: 40px;
  padding: 16px 0 24px;
  width: 100%;
  justify-content: space-between;
  
  @include mobile {
    gap: 17px;
  }
}
.node-num {
  font-size: 48px;
  line-height: 58px;
  font-weight: 700;

  @include mobile {
    font-size: 42px;
    line-height: 50px;
  }
}
.node-text {
  font-size: 14px;
  line-height: 17px;

  @include mobile {
    font-size: 12px;
    line-height: 15px;
  }
}
.ft64 {
  font-size: 64px;
  line-height: 77px;
}
</style>
